import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AdminSiteEditor.css";

const AdminSiteEditor = () => {
  const [data, setData] = useState(null);
  const [editedData, setEditedData] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [dropdownState, setDropdownState] = useState({});
  const [searchTerm, setSearchTerm] = useState("");



  useEffect(() => {
    axios
      .get("https://json-backend.vercel.app/json/6752cad34d7aacfedf5eea87")
      .then((response) => {
        const responseData = response.data.data;
        if (Array.isArray(responseData)) {
          setData(responseData);
          setEditedData(responseData);
          setFilteredData(responseData);
          console.log("API Response:", response.data);
        } else {
          console.error("Unexpected data format:", responseData);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (!term) {
      setFilteredData(editedData || []);
      return;
    }
  
    const filterDataBySearchTerm = (obj, path = "") => {
      if (obj == null) return null; // Handle null or undefined
    
      if (typeof obj !== "object") {
        if (String(obj).toLowerCase().includes(term)) {
          return { matched: true, value: obj };
        }
        return null;
      }
    
      if (Array.isArray(obj)) {
        const filteredArray = obj
          .map((item, index) =>
            item ? filterDataBySearchTerm(item, `${path}[${index}]`) : null
          )
          .filter((item) => item !== null);
    
        if (filteredArray.length > 0) {
          return { matched: true, value: filteredArray };
        }
        return null;
      }
    
      const filteredObject = Object.entries(obj).reduce((acc, [key, value]) => {
        const keyMatches = key.toLowerCase().includes(term);
        const filteredValue = filterDataBySearchTerm(
          value,
          path ? `${path}.${key}` : key
        );
        if (keyMatches || filteredValue) {
          acc[key] = keyMatches ? value : filteredValue?.value;
        }
        return acc;
      }, {});
    
      if (Object.keys(filteredObject).length > 0) {
        return { matched: true, value: filteredObject };
      }
      return null;
    };
    
  
    const filtered = (editedData || [])
      .map((item, index) => filterDataBySearchTerm(item, `${index}`))
      .filter((item) => item !== null)
      .map((item) => item.value);
  
    setFilteredData(filtered);
  };
  

  const toggleDropdown = (path) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [path]: !prevState[path],
    }));
  };

  const handleFieldChange = (path, value, isKey = false) => {
    setEditedData((prevData) => {
      const newData = JSON.parse(JSON.stringify(prevData));
      const keys = path.split(".");
      let current = newData;

      keys.forEach((key, index) => {
        const arrayMatch = key.match(/(.+)\[(\d+)\]/);
        if (arrayMatch) {
          const [_, arrayKey, arrayIndex] = arrayMatch;
          if (!Array.isArray(current[arrayKey])) {
            current[arrayKey] = []; // Ensure it's an array
          }
          current = current[arrayKey][parseInt(arrayIndex)] || {}; // Safely access index
        } else if (index === keys.length - 1) {
          if (isKey) {
            const parent = keys
              .slice(0, -1)
              .reduce((acc, k) => {
                const match = k.match(/(.+)\[(\d+)\]/);
                return match ? acc[match[1]][parseInt(match[2])] : acc[k];
              }, newData);
            parent[value] = current[key];
            delete current[key];
          } else {
            current[key] = value;
          }
        } else {
          if (!current[key]) {
            current[key] = {}; // Ensure the object exists
          }
          current = current[key];
        }
      });
      

      return newData;
    });
  };

  const renderFields = (obj, path = "") => {
    if (typeof obj !== "object" || obj === null) {
      return (
        <div className="field">
          <label className="EditorLabel">Value:</label>
          <input
            type="text"
            value={obj || ""}
            onChange={(e) => handleFieldChange(path, e.target.value)}
          />
        </div>
      );
    }
  
    if (Array.isArray(obj)) {
      return (
        <div className="array">
          <div className="array-header" onClick={() => toggleDropdown(path)}>
            <span>
              {path || "Array"} (Click to {dropdownState[path] ? "Collapse" : "Expand"})
            </span>
          </div>
          {dropdownState[path] && (
            <div className="array-content">
              {(obj || []).map((item, index) =>
                item ? (
                  <div key={index} className="array-item">
                    {renderFields(item, `${path}[${index}]`)}
                  </div>
                ) : (
                  <div key={index} className="array-item">Empty Item</div>
                )
              )}
              <button
                className="add-item"
                onClick={() => handleFieldChange(path, [...obj, {}])}
              >
                Add Item
              </button>
            </div>
          )}
        </div>
      );
    }
    
    
  
    return (
      <div className="object">
        {Object.entries(obj).map(([key, value]) => (
          <div key={key} className="object-field">
            <label className="EditorLabel">Key:</label>
            <input
              className="field-key"
              type="text"
              value={key}
              onChange={(e) =>
                handleFieldChange(path ? `${path}.${key}` : key, e.target.value, true)
              }
            />
            {renderFields(value, path ? `${path}.${key}` : key)}
          </div>
        ))}
        <button
          className="add-field"
          onClick={() => handleFieldChange(path, { ...obj, newField: "" })}
        >
          Add Field
        </button>
      </div>
    );
  };
  

  const handleSave = () => {
    const documentId = "6752cad34d7aacfedf5eea87";
    axios
      .put(`https://json-backend.vercel.app/json/${documentId}`, { data: editedData })
      .then((response) => {
        console.log("Response:", response.data);
        alert("Data saved successfully!");
      })
      .catch((error) => {
        console.error("Error:", error.response ? error.response.data : error.message);
        alert("Failed to save data!");
      });
  };

  if (!data) return <div>Loading...</div>;

  return (
    <div className="admin-site-editor">
      <h1>Admin Site Editor</h1>
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearch}
        className="Adminsearch-input"
      />
      <div className="fields-container">
  {(filteredData || []).map((item, index) =>
    item ? (
      <div key={index} className="data-item">
        {renderFields(item, `${index}`)}
      </div>
    ) : null
  )}
</div>


      <button onClick={handleSave} className="save-button">
        Save Changes
      </button>
    </div>
  );
};

export default AdminSiteEditor;
